import * as alertAnimations from "../assets/animations/Alert.json";
import Lottie from "react-lottie";

const Error = () => {
  return (
    <div className="font-primaryFont font-light flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
      <div className="mt-20 flex flex-col md:flex-row md:justify-center items-center">
        <div className="mx-auto max-w-sm md:max-w-md">
          <Lottie
            options={{
              animationData: alertAnimations,
              rendererSettings: {
                preserveAspectRatio: "xMidYMid slice",
              },
            }}
            height={100}
            width={100}
            className="w-1/2 md:w-4/12"
          />
          <h1 className="mt-4 text-center text-2xl">
            Registration link has expired or disabled. Please contact{" "}
            <a
              href="mailto:vespid.tech@gmail.com"
              className=" text-primaryOrange"
            >
              vespid.tech@gmail.com{" "}
            </a>{" "}
            or your IT department for support.
          </h1>
        </div>
      </div>
    </div>
  );
};

export default Error;
